import axios from "axios";

let SERVER_URL = "/api/waitlist-service";
let CLOUD_CRM_URL = "/api/public-crm";
if (process.env.REACT_APP_ENV === "dev") {
  // SERVER_URL = "http://35.165.212.63:3033/waitlist-service"
  SERVER_URL = "https://cloud.menusifudev.com/api/waitlist-service";
  CLOUD_CRM_URL = "https://cloud.menusifudev.com/api/public-crm";
}

export const getWaitListByMerchantId = (merchantId) => {
  return axios({
    url: SERVER_URL + "/customer/waitlist/" + merchantId,
    method: "GET",
  });
};

export const getMerchantByMerchantId = (merchantId) => {
  return axios({
    url: SERVER_URL + "/customer/merchant/" + merchantId,
    method: "GET",
  });
};

export const createNewWait = (merchantId, newWait) => {
  return axios({
    url: SERVER_URL + `/customer/waitlist/${merchantId}/new`,
    data: newWait,
    method: "POST",
  });
};

export const leaveWaitlist = (id) => {
  return axios({
    url: SERVER_URL + `/customer/waitlist/leave/${id}`,
    method: "DELETE",
  });
};

export const getWaitTicketById = (id) => {
  return axios({
    url: SERVER_URL + `/customer/waitlist/ticket_v2/${id}`,
    method: "GET",
  });
};

export const getLastUpdateTime = (merchantId) => {
  return axios({
    url: SERVER_URL + `/customer/waitlist/${merchantId}/lastUpdateTime`,
    method: "GET",
  });
};

/**
 *  CRM 相关
 **/
// 查询是否是会员
export const isCRMMember = ({ merchantId, phone }) => {
  return axios({
    url: `${CLOUD_CRM_URL}/agent?agentId=65bac3aa6c62b39ed3f3e657`,
    data: { merchantId, phone },
    method: "POST",
  });
};
// 查询 onboarding rule
export const getOnBoardingRule = (merchantId) => {
  return axios({
    url: `${CLOUD_CRM_URL}/agent?agentId=62212a66103d63bd57f30123`,
    data: { merchantId },
    method: "POST",
  });
};
// 注册会员
export const registerCRM = (data) => {
  return axios({
    url: `${CLOUD_CRM_URL}/agent?agentId=64a2857e6c62b39ed3e12a6c`,
    data,
    method: "POST",
  });
};
// 查询其他 crm rule
export const queryCRMRule = ({ merchantId }) => {
  return axios({
    url: `${CLOUD_CRM_URL}/agent?agentId=649341026c62b39ed3e44c96`,
    data: { merchantId },
    method: "POST",
  });
};
// 查询crm开通情况
export const queryCRMStatus = ({ merchantId }) => {
  return axios({
    url: `${CLOUD_CRM_URL}/agent?agentId=64acf8436c62b39ed33dc0e4`,
    data: { merchantId },
    method: "post",
  });
};
// 查询crm开关
export const queryCRMSwitch = ({ merchantId }) => {
  return axios({
    url: `${CLOUD_CRM_URL}/agent?agentId=622b7118103d63bd57424a59`,
    data: { merchantId },
    method: "post",
  });
};
